import React, { useDebugValue, useEffect, useRef, useState } from "react"
import { graphql, Link } from "gatsby"

import { connect } from 'react-redux';
import { addToCartMessage } from '../store/actions';

import Layout from "../components/layout"
import SEO from "../components/seo"

import "../scss/products.scss";
import 'uikit/dist/css/uikit.css'

import headerBgImage from "../assets/img/pexels-pixabay-158385.jpg"
import Button from "../components/basic-components/button";

import CustomMarkdown from "../utils/customMarkdown"
import CategoryBar from "../components/category-bar";
import { MdOutlineArrowBackIosNew, MdOutlineArrowForwardIos } from 'react-icons/md'
import { FaCheckCircle, FaHourglassEnd } from "react-icons/fa";
import { navigate } from "gatsby-link";

import { getAllProducts } from '../store/selectors';

import { emptyCartMessage } from '../store/actions';

//import EnquiryPopup from "../components/enquiry-popup";
//import loadable from '@loadable/component'
//const EnquiryPopup = loadable(() => import("../components/enquiry-popup"))





var productImage = "https://picsum.photos/seed/picsum/1200";
var productMaterial = "https://picsum.photos/seed/picsum/100";

const BaseUrl = "https://memorials.phaeria.com"

var headerTitle = "Beautiful, distinctive and affordable memorials";
var headerDescription = "Dolore non qui ea quis nulla. Qui velit cupidatat Lorem voluptate id aliquip. In eiusmod non cillum minim Lorem duis.";
var headerCTAPrimaryLabel = "View Collections";
var headerCTAPrimaryUrl = "#0";
var headerCTASecondaryLabel = "Speak to one of the team";
var headerCTASecondaryUrl = "#0";


var pageData = {
  headerTitle,
  headerDescription,
  headerCTAPrimaryLabel,
  headerCTAPrimaryUrl,
  headerCTASecondaryLabel,
  headerCTASecondaryUrl,
  headerBgImage,
  headerLeftBgColor: '',
  headerRightBgColor: '',
};


export const query = graphql`
  query ProductsQuery($id: Int) {
    jrmProducts(Id: {eq: $id}) {
      PayOnline
      HidePrices
      Name
      Description
      AttractivePrice
      NotAttractivePrice
      Id
      
    }

    allJrmProductImages(filter: {SDItemId: {eq: $id}}) {
      edges {
        node {
          Path
          SDItemId
          Description
          Id
        }
      }
    }

    allJrmCategories {
      nodes {
        Id
        Name
      }
    }

    allJrmFilteredCategories {
      nodes {
          Id
      }
    }

    allJrmProductsMaterials(filter: {Id: {eq: $id}}) {
      nodes {
        Name
        Id
        AttractivePrice
        Image
        BandPrice
        MaterialName
        NotAttractivePrice
        MaterialId
        Image
        ItemsShowProductOptionsOnFrontend
      }
    }

    

    allJrmProductsSizes(filter: {Id: {eq: $id}}) {
      nodes {
        Name
        Id
        AttractivePrice
        Height
        Length
        Width
        PriceType
        SizeId
        SizePrice
        NotAttractivePrice
      }
    }  
    allJrmProductsFinishes(filter: {Id: {eq: $id}}) {
      nodes {
        Name
        Id
        FinishesId
        FinishesName
        FinishesPrice
      }
    }

  }
`



const Products = ({ data, products, addToCart, emptyCart }) => {


  //console.log(products, "tetstt")

  //local vars
  // var materialsVar = {materialId: "", materialName: ""}
  var materialsList = []
  var sizesList = []

  var orderProducts = []



  var selectedBandPrice
  var selectedPriceType
  var selectedSizePrice
  var selectedInitialPrice
  var selectedMaterialId
  var selectedSizeId
  var netPrice
  var VAT = 1.2
  var priceWithVat
  var selectedFinishPrice;
  var selectedFinishId;
  var selectedFinishName;



  var FilteredCategories = []
  data.allJrmCategories.nodes.forEach((item, index) => {
    var exists = data.allJrmFilteredCategories.nodes.find(filteredItem => filteredItem.Id === item.Id)
    if (exists) {
      FilteredCategories.push({
        Id: item.Id,
        Name: item.Name
      })
    }
  })
  const finishes = data.allJrmProductsFinishes.nodes



  // console.log('material: ', selectedMaterialId, 'size: ', selectedSizeId, selectedFinishId)





  // display size/material/finishes

  const productOptions = data.allJrmProductsMaterials?.nodes[0]?.ItemsShowProductOptionsOnFrontend !== null ? data.allJrmProductsMaterials.nodes[0]?.ItemsShowProductOptionsOnFrontend.split(',') : ''






  const [prodQty, setCount] = useState(1);

  const handleIncrement = () => {
    setCount(prevCount => prevCount + 1)
    // setPrice(prodPrice * prodQty)
    /*
    console.log("increment");
    if (typeof window !== 'undefined'){
     console.log("triggerGA");
     //window.ga('send', 'event', 'TriggerIncrement', 'submit');
     window.gtag('event', 'trigger-increment');
    }
    */
  }
  const handleDecrement = () => {
    setCount(prevCount => prevCount > 1 ? prevCount - 1 : prevCount = 1)
    // setPrice(prodPrice * prodQty)
  }

  //dummy product
  var product = {
    name: '',
    id: '',
    itemId: '',
    materialId: '',
    sizeId: '',
    quantity: '',
    price: '',
    image: '',
    hidePrice: false,
    finishId: ''

  }



  // function showMessage(){
  //   console.log("message")
  //   const msg = document.querySelector(".product__add__btn__message")
  //   // msg.classList.add("asdf")
  //   msg.classList
  //   console.log(msg)
  // }

  const [addedToBasket, setActive] = useState(false)

  const toggleAddedToBasket = () => {
    setActive(true)
    // console.log("added: ",addedToBasket)
  }


  //vars with content from graphql
  const page = data.jrmProducts
  const productImages = data.allJrmProductImages.edges.length > 0 ? data.allJrmProductImages : null
  const productMaterials = data.allJrmProductsMaterials
  const productSizes = data.allJrmProductsSizes


  const [selectedFinishTypeId, setSelectedFinishTypeId] = useState(finishes[0].FinishesId)
  const [selectedFinishTypePrice, setSelectedFinishTypePrice] = useState(finishes[0].FinishesPrice)




  //initialize finishes variables 


  finishes.map((item, index) => {
    if (index === 0) {
      selectedFinishId = item.FinishesId

      // setSelectedFinishId(item.FinishesId)
      selectedFinishPrice = item.FinishesPrice
      selectedFinishName = item.FinishesName
    }
  })



  productMaterials.nodes.map((item, key) => {
    // data from the query contains duplicate values and I created a new array that contains only unique values

    if (key === 0) {
      //try to refactor with useState to save the state when I change size or finish

      // selectedBandPrice = item.BandPrice
      // selectedMaterialId = item.MaterialId
    }


    var findMaterials = materialsList.find(x => x.materialId === item.MaterialId)

    if (!findMaterials) {
      materialsList.push({
        materialId: item.MaterialId,
        materialName: item.MaterialName,
        bandPrice: item.BandPrice,
        materialImage: item.Image
      })
    }


    return ("")
  })

  productSizes.nodes.map((item, key) => {
    // materialsList.push(item.MaterialName, item.MaterialId)

    // data from the query contains duplicate values and I created a new array that contains only unique values


    if (key === 0) {
      selectedPriceType = item.PriceType
      selectedSizePrice = item.SizePrice
      // selectedSizeId = item.SizeId
    }
    var findSizes = sizesList.find(x => x.sizeId === item.SizeId)
    if (!findSizes) {
      sizesList.push({
        sizeId: item.SizeId,
        width: item.Width,
        height: item.Height,
        length: item.Length,
        priceType: item.PriceType,
        sizePrice: item.SizePrice

      })
    }
    // updatePrice()
    return ("")
  })


  // const [selectedFinishId, setSelectedFinishId] = useState(finishes[0].FinishesPrice)
  // const [selectedMaterialId, setSelectedMaterialId] = useState(productMaterials[0].MaterialId)
  // const [selectedSizeId, setSelectedSizeId] = useState(productSizes[0].SizeId)

  calcNetPrice()

  const [prodPrice, setPrice] = useState()



  //functions to handle the selection of materials and sizes

  const [activeId, setActiveId] = useState()



  // const [selectedFinishType, setSelectedFinishType] = useState(finishes[0].FinishesId)



  function materialHandle(attr, id) {

    selectedBandPrice = attr.bandPrice
    selectedMaterialId = attr.materialId


    setActiveId(id)
    updatePrice()
  }





  function sizeHandle(attr) {
    selectedPriceType = attr.priceType
    selectedSizePrice = attr.sizePrice
    selectedSizeId = attr.sizeId
    //  console.log('size id',attr.sizeId)
    // setSelectedSizeId(attr.sizeId)

    updatePrice()
  }


  function handleFinish(item) {
    setSelectedFinishTypeId(item.FinishesId)
    selectedFinishPrice = item.FinishesPrice
    selectedFinishId = item.FinishesId
    selectedFinishName = item.FinishesName


    setSelectedFinishTypePrice(item.FinishesPrice)

    updatePrice()
  }

  function updatePrice() {
    calcNetPrice()
    // setPrice(netPrice )
    setPrice(Math.round(netPrice * VAT * 100) / 100)

    //updates product basket object's info
    product.name = page.Name
    product.id = page.Id + '-' + selectedMaterialId + '-' + selectedSizeId + '-' + selectedFinishTypeId
    product.itemId = page.Id
    product.materialId = selectedMaterialId
    product.sizeId = selectedSizeId
    product.price = netPrice
    product.hidePrice = page.HidePrices
    product.finishId = selectedFinishTypeId

    // console.log('product.hide', product.hidePrice)


  }

  useEffect(() => {
    updatePrice()
  }, [selectedFinishTypeId])

  //sets the initial product var to be able to add the product to basket without making any other selections on the page
  product.name = page.Name
  product.id = page.Id + '-' + selectedMaterialId + '-' + selectedSizeId + '-' + selectedFinishTypeId
  product.itemId = page.Id
  product.materialId = selectedMaterialId
  product.sizeId = selectedSizeId
  product.finishId = selectedFinishTypeId
  // product.price = netPrice 
  product.price = netPrice * VAT
  product.hidePrice = page.HidePrices



  // console.log('product.hide', product.hidePrice)

  function calcNetPrice() {

    selectedInitialPrice = (selectedPriceType === 0) ? page.AttractivePrice : page.NotAttractivePrice
    //console.log("calcNetPrice:", page.AttractivePrice, page.NotAttractivePrice, selectedInitialPrice, selectedSizePrice, selectedBandPrice, selectedFinishPrice);
    if (!selectedSizePrice) { selectedSizePrice = 100; }
    if (!selectedBandPrice) { selectedBandPrice = 100; }
    if (!selectedFinishPrice) { selectedFinishPrice = 100; }
    // the selected price * 100 and then divide 100 to round on 2 decimals. the rest are the percentage per size/band/finish if added on.
    netPrice = Math.round(selectedInitialPrice * 100 * selectedSizePrice / 100 * selectedBandPrice / 100 * selectedFinishPrice / 100) / 100
    //console.log("checkPrice:", netPrice)
  }

  // onClick full width image


  const [openModal, setOpenModal] = useState(false)
  const [index, setIndex] = useState(0)
  const source = []

  productImages.edges.map((item) => {

    source.push({ image: process.env.GATSBY_IMAGE_PATH_URL + "/" + item.node.Path, description: item.node.Description })

  })


  //get the current src 
  const getSrc = (src, id) => {
    setOpenModal(true)
    const index = source.findIndex(item => item.image === src)
    setIndex(index)
  }
  //stop body scroll when modal is open

  if (openModal) {
    document.body.setAttribute('style', `position:fixed; top: 0; left:0; right:0;`)
  } else {
    document.body.setAttribute('style', ``)
  }



  //Click outside the image to close the modal

  const imageContainer = useRef()

  useEffect(() => {
    const handleMouseDown = (e) => {
      if (!imageContainer.current.contains(e.target)) {
        setOpenModal(false)
      }
    }
    document.addEventListener('mousedown', handleMouseDown);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown)

    }
  })

  // check if index is the last of the array or the first element

  function checkIndex(number) {
    if (number < 0) {
      return source.length - 1;
    }

    if (number > source.length - 1) {
      return 0;
    }
    return number;
  }

  //key down events: close modal, change slide

  useEffect(() => {
    const handleKeyDown = (e) => {
      const lastIndex = source.length - 1;
      //console.log(lastIndex)

      if (e.key === "ArrowRight") {
        setIndex((index) => {
          let newIndex = index + 1;
          return checkIndex(newIndex);
        });
      }
      if (e.key === 'ArrowLeft') {
        setIndex((index) => {
          let newIndex = index - 1;
          return checkIndex(newIndex);
        });
      }
      if (e.key === "Escape") {
        setOpenModal(false)
      }
    }
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  })


  // const handleGtag = (title) => {
  //   if (typeof window !== 'undefined' && typeof window.gtag !== 'undefined') {

  //     window.gtag('event', 'add_to_cart', { 'event_category': 'ecommerce', 'event_label': `${title}` });

  //   }
  // }



  const [imageId, setImageId] = useState('')
  useDebugValue(imageId == null ? 'no id' : imageId)



  const imagesRef = useRef([])
  imagesRef.current = []

  const addToRefs = (elem) => {
    if (elem && !imagesRef.current.includes(elem)) {
      imagesRef.current.push(elem)
    }
  }

  console.log("[>>] products.js:" + products)


  return (

    <Layout pageData={pageData} headerShow={false}>

      <SEO title={page.Name} />

      {/* <CategoryBar data={FilteredCategories}></CategoryBar> */}
      {/* <DebugCart></DebugCart> */}


      <div className="section-container">
        <div className="products-section-wrapper lateral-padding">
          <div className="tiles-section uk-grid" data-uk-grid> {/*uk-child-width-1-2@s*/ }
            <div className="left-column-container uk-width-1-1 uk-width-3-5@m">
              <div className="uk-position-relative uk-visible-toggle uk-light" tabindex="-1" data-uk-slideshow="animation: scale">
                {/* <p>test</p> */}
                <ul className="uk-slideshow-items mobile-images-ratio" >
                  {productImages ? productImages.edges.map((item, index) => {
                    if (index === 0) product.image = process.env.GATSBY_IMAGE_PATH_URL + "/" + item.node.Path
                    return (
                      <li key={index} className={`product-slideshow-item-background ${item.node.Id === imageId ? 'uk-active' : ''}`} ref={addToRefs}>
                        <div className="uk-position-cover uk-transform-origin-top-center">

                          <img data-src={process.env.GATSBY_IMAGE_PATH_URL + "/" + item.node.Path} className='full-width-image uk-object-contain uk-height-1-1' alt="" data-uk-img="target: !ul > :last-child, !* +*" onClick={e => getSrc(e.target.src)} />
                        </div>
                      </li>
                    )
                  }) : <li>
                    <img data-src={process.env.GATSBY_DEFAULT_NA_IMAGE} width="1800" height="1200" alt="" className='full-width-image' data-uk-cover data-uk-img="target: !ul > :last-child, !* +*" onClick={e => getSrc(e.target.src)} />
                  </li>}
                </ul>




                <div className={`${openModal ? "show-modal " : "modal"}`}>
                  <span className='number-of-images'>{index + 1 + '/' + source.length}</span>
                  <span className="close" onClick={() => setOpenModal(false)}>&times;</span>
                  <div className='uk-position-center image-container ' ref={imageContainer} >


                    {source.length > 1 ? <span data-uk-icon="icon:  chevron-left; ratio: 2" className='slideshow-arrow-left' onClick={() => setIndex((index) => {let newIndex = index - 1; return checkIndex(newIndex);})}></span> : ''}

                    <div className="image-parent" tabindex="0">
                      <img src={source[index].image} className='slide-image' />
                    </div>

                    {source.length > 1 ? <span data-uk-icon="icon: chevron-right; ratio: 2" className='slideshow-arrow-right' onClick={() => setIndex((index) => {let newIndex = index + 1; return checkIndex(newIndex);})}></span> : ''}
                  </div>


                </div>

                <button className="uk-position-center-left uk-position-small uk-hidden-hover" href="#0" data-uk-slidenav-previous data-uk-slideshow-item="previous" aria-label="view-previous-image"
                  onClick={() => setIndex((index) => {
                    let newIndex = index - 1;
                    return checkIndex(newIndex);
                  })}
                ></button>

                <button className="uk-position-center-right uk-position-small uk-hidden-hover" href="#0" data-uk-slidenav-next data-uk-slideshow-item="next" aria-label="view-next-image"
                  onClick={() => setIndex((index) => {
                    let newIndex = index + 1;
                    return checkIndex(newIndex);
                  })}
                ></button>

              </div>

              {/* images slideshow */}
              <div className="slideshow-container">

                <div data-uk-slider>
                  <ul className="uk-slider-items uk-child-width-1-3 uk-grid-match slideshow-single-image-container">
                    {
                      productImages ? productImages.edges.map((item, index) => {

                        return <li className="slideshow-single-image" key={index}>
                          <img src={process.env.GATSBY_IMAGE_PATH_URL + "/" + item.node.Path} height='150' alt={item.node.Description} onClick={() => {
                            setImageId(item.node.Id)
                            setIndex(index)
                          }} />
                        </li>
                      }) : ''
                    }

                  </ul>
                </div>

                {/* images description */}

                <p className='image-description'>{source[index]?.description}</p>
              </div>

            </div>
            <div className="right-column-container uk-width-1-1 uk-width-2-5@m">

              <h1 className="product-name">{page.Name.toLowerCase()}</h1>

              <div className="product-description-panel">
                <CustomMarkdown children={page.Description} />
              </div>




              {/*===================================== */}


              {
                productOptions ? <div className="product-customisation">
                  <ul className="product-customisation-accordion" data-uk-accordion="collapsible: true">

                    {
                      productOptions.map((item) => {
                        if (item == 0) {
                          return <li className="uk-open">
                            {
                              materialsList.length === 1 || materialsList.length === 0 ? (materialsList[0] ? (<>
                                <div className="product-price">{prodPrice} <span className='vat'>inc. VAT</span></div>
                                <div className="material-selection"> Material: <img className="material-thumb" src={materialsList[0].materialImage ? process.env.GATSBY_IMAGE_PATH_URL + "/" + materialsList[0].materialImage : process.env.GATSBY_DEFAULT_NA_IMAGE} width="50" height="50" alt={materialsList[0].materialName.toLowerCase()} />{`   ${materialsList[0].materialName.toLowerCase()}`}</div>
                              </>) : (''//return nothing for no materials
                              ))
                                :
                                (
                                  <>
                                    <a className="uk-accordion-title" href="#0">1. Choose material</a>
                                    <div className="uk-accordion-content">
                                      <ul className="uk-thumbnav " data-uk-margin>
                                        {(materialsList.map((item) => {

                                          return (
                                            <li key={item.materialId} className="material-selection"><div
                                              onClick={() => materialHandle(item, item.materialId)}><img className="material-thumb" src={item.materialImage ? process.env.GATSBY_IMAGE_PATH_URL + "/" + item.materialImage : process.env.GATSBY_DEFAULT_NA_IMAGE} width="50" height="50" alt={item.materialName.toLowerCase()} />

                                              <span className={item.materialId === activeId ? 'active material-selection' : 'material-selection'}>
                                                {item.materialName.toLowerCase()}
                                              </span> </div></li>
                                          )
                                        })
                                        )}
                                      </ul>
                                    </div>
                                  </>

                                )
                            }

                          </li>
                        }


                        if (item == 1) {
                          return <li>

                            {
                              sizesList.length === 1 || sizesList.length === 0 ?
                                (
                                  !sizesList[0] ? (
                                    <div >
                                      <p>Dimensions: Width: {sizesList[0].width}cm x Height: {sizesList[0].height}cm x Length: {sizesList[0].length}cm</p>
                                    </div>) : (''))
                                : (<>

                                  <a className="uk-accordion-title" href="#0">2. Choose a size</a>
                                  <div className="uk-accordion-content">
                                    {/* <input className="uk-input" type="text" placeholder=""/> */}
                                    <ul className="uk-thumbnav ">
                                      {sizesList.map((item, index) => {
                                        {/* console.log('sizelist',sizesList) */ }
                                        return (
                                          <li key={index}>
                                            <label><input className="uk-radio" type="radio" name="radio" onClick={e => sizeHandle(item)} />
                                              Width: {item.width}cm x Height: {item.height}cm x Length: {item.length}cm.
                                            </label>
                                          </li>
                                        )
                                      })}

                                    </ul>
                                  </div>
                                </>
                                )
                            }



                          </li>
                        }


                        if (item == 2) {
                          return <li>

                            {
                              finishes.length === 1 ? (<div >

                                <p onClick={() => handleFinish(item)}> {finishes.FinishesName}</p>
                              </div>) : (<>

                                <a className="uk-accordion-title" href="#0">3. Choose a finish</a>
                                <div className="uk-accordion-content">

                                  <ul className="uk-thumbnav ">
                                    {finishes.map((item, index) => {

                                      return (
                                        <li key={index}>
                                          <label><input className="uk-radio" type="radio" value={item.FinishesId} name="radio-finish"
                                            onChange={() => handleFinish(item)} />
                                            {item.FinishesName}
                                          </label>
                                        </li>
                                      )
                                    })}

                                  </ul>
                                </div>
                              </>
                              )
                            }


                          </li>
                        }


                      })
                    }


                  </ul>
                </div> : ''

              }


              {/* 
             {/*===================================== */}




              {materialsList.length === 1 || page.HidePrices ? '' : <div className="product-price">{prodPrice} <span className='vat'>inc. VAT</span> </div>}


              {!page.HidePrices ? <div className="product-customisation">
                <ul className="product-customisation-accordion" uk-accordion="collapsible: false">
                  <li>
                    {
                      materialsList.length === 1 || materialsList.length === 0 ? (materialsList[0] ? (<>
                        <div className="product-price">{prodPrice} <span className='vat'>inc. VAT</span></div>
                        <div className="material-selection"> Material: <img className="material-thumb" src={materialsList[0].materialImage ? process.env.GATSBY_IMAGE_PATH_URL + "/" + materialsList[0].materialImage : process.env.GATSBY_DEFAULT_NA_IMAGE} width="50" height="50" alt={materialsList[0].materialName.toLowerCase()} />{`   ${materialsList[0].materialName.toLowerCase()}`}</div>
                      </>) : (''//return nothing for no materials
                      ))
                        :
                        (
                          <>
                            <a className="uk-accordion-title" href="#0">1. Choose material</a>
                            <div className="uk-accordion-content">
                              <ul className="uk-thumbnav " data-uk-margin>
                                {(materialsList.map((item) => {

                                  return (
                                    <li key={item.materialId} className="material-selection"><div
                                      onClick={() => materialHandle(item, item.materialId)}><img className="material-thumb" src={item.materialImage ? process.env.GATSBY_IMAGE_PATH_URL + "/" + item.materialImage : process.env.GATSBY_DEFAULT_NA_IMAGE} width="50" height="50" alt={item.materialName.toLowerCase()} />

                                      <span className={item.materialId === activeId ? 'active material-selection' : 'material-selection'}>
                                        {item.materialName.toLowerCase()}
                                      </span> </div></li>
                                  )
                                })
                                )}
                              </ul>
                            </div>
                          </>

                        )
                    }

                  </li>
                  <li>
                    {
                      sizesList.length === 1 || sizesList.length === 0 ?
                        (
                          !sizesList[0] ? (
                            <div >
                              <p>Dimensions: Width: {sizesList[0].width}cm x Height: {sizesList[0].height}cm x Length: {sizesList[0].length}cm</p>
                            </div>) : (''))
                        :
                        (<>

                          <a className="uk-accordion-title" href="#0">2. Choose a size</a>
                          <div className="uk-accordion-content">
                            {/* <input className="uk-input" type="text" placeholder=""/> */}
                            <div className="uk-margin uk-grid-small uk-child-width-auto" data-uk-grid>
                              {sizesList.map((item, index) => {
                                {/* console.log('sizelist',sizesList) */ }
                                return (
                                  <div key={index}>
                                    <label><input className="uk-radio" type="radio" name="radio" onClick={e => sizeHandle(item)} />
                                      Width: {item.width}cm x Height: {item.height}cm x Length: {item.length}cm.
                                    </label>
                                  </div>
                                )
                              })}

                            </div>
                          </div>
                        </>
                        )
                    }


                  </li>
                </ul>
              </div> : ''}




              {sizesList.length === 1 || page.HidePrices ? '' : <div className="product-price">{prodPrice} <span className='vat'>inc. VAT</span></div>}


              <div className="product-quantity">Qty.
                <button onClick={handleDecrement} >-</button>
                <span>{prodQty}</span>
                <button onClick={handleIncrement}>+</button>
              </div>


              <div className="product-add-btn">
                {/* <a onClick={() => addItem(product)} href="#0" aria-label="add to basket"><Button use="addToCart" label="Add to cart"></Button></a> */}
                <a onClick={() => {
                  addToCart(product, prodQty)
                  toggleAddedToBasket()
                  //handleGtag(page.Name)
                }} href="#enquiry-popup" aria-label="add to basket"><Button use="addToCart" label={page.HidePrices ? "Get a quote" : "Add to cart"}></Button></a>

              </div>

              <div className={(addedToBasket && page.HidePrices) ? "product__add__btn__message uk-animation-slide-top showMessage" : "product__add__btn__message"}>
                {/* <FaCheckCircle color={"#2E9F71"}/>
                Item added in the basket. Go to <Link to={"/checkout"}>Checkout</Link> to finish your enquiry */}



              </div>



            </div>{/** end of right column */}

          </div>
        </div>
      </div>

      {products.map(({ product, count }, i) => {

        orderProducts.push({
          "ItemId": product.itemId,
          "MaterialId": product.materialId,
          "SizeId": product.sizeId,
          "Quantity": 1,
          "HidePrices": product.hidePrice
        })
      })
      }

    </Layout>
  )
}

function mapStateToProps({ cartReducer }) {
  return {
    products: getAllProducts(cartReducer)
  };
}

const mapDispatchToProps = {
  addToCart: (product, count) => addToCartMessage(product, count),
  emptyCart: product => emptyCartMessage(product),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Products);